import { render } from "./Collection.vue?vue&type=template&id=25c1ef03&lang=pug"
import script from "./Collection.vue?vue&type=script&lang=ts"
export * from "./Collection.vue?vue&type=script&lang=ts"
script.render = render

export default script